var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunriseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v3M4.9 6.9l2.1 2.1M2 16h3M19 16h3M17 9l2.1-2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16a4 4 0 0 1 8 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20h18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunriseIcon);
export default __webpack_public_path__ + "static/media/SunriseIcon.f38cd22cb8e13965df894f4ed743994a.svg";
export { ForwardRef as ReactComponent };